<!-----选择谈判单列表------>
<template>
  <div class="card">
    <div class="section">
      <div class="section-title">
        <base-section-title>
          <div class="choose-title flex">
            已选谈判单
            <choose-negotiation-v-2-drawer
              v-if="canEditOrder"
              class="m-l-10"
              :selected="orderList"
              :in-status="inStatus"
              @change="setOrderList"
            />
            <span>已选{{ orderList.length }}个谈判单</span>
          </div>
          <div slot="right-tool" class="choose-operation flex">
            <el-input
              v-model="negotiationName"
              class="m-r-10"
              placeholder="请输入谈判名称"
              clearable
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search()"
              />
            </el-input>
            <choose-negotiation-v-2-drawer
              v-if="!canEditOrder"
              :selected="orderList"
              :in-status="inStatus"
              @change="setOrderList"
            />
            <template v-if="canEditOrder">
              <el-button
                v-if="!editOpen"
                type="text"
                @click="editOpen = true"
              >编辑谈判单</el-button>
              <el-button
                v-if="editOpen"
                type="text"
                @click="saveEditOrder"
              >保存</el-button>
              <el-button
                v-if="editOpen"
                type="text"
                @click="cancelEditOrder"
              >取消</el-button>
            </template>
          </div>
        </base-section-title>
      </div>
      <div class="section-content">
        <div class="order-list">
          <div v-if="filterOrderList.length">
            <div
              v-for="(item, index) in filterOrderList"
              :key="item.orderId"
              class="flex-align__between order-list_content"
            >
              <div class="order">
                <div v-if="!editOpen" class="order_title">
                  {{ item.orderName }}
                </div>
                <el-input
                  v-else
                  v-model="item.orderName"
                  style="width: 400px"
                  maxlength="200"
                  placeholder="请输入谈判单名称"
                />
                <div class="order_tip">
                  采购项目名称：{{ item.projectName || '-' }}
                </div>
              </div>
              <el-button
                type="text"
                class="text-danger m-r-16"
                @click="remove(index)"
              >移除</el-button>
            </div>
            <!-- 分页 -->
            <pagination
              v-show="total"
              ref="pagination"
              :total="total"
              :page.sync="page"
              :limit.sync="size"
              @pagination="search"
            />
          </div>
          <div v-else class="no-data">
            <img
              :src="require(`@/assets/images/empty/list_no_content.png`)"
              alt=""
            />
            <div class="no-data_content">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import ChooseNegotiationV2Drawer from './ChooseNegotiationV2Drawer'
import Pagination from '@/components/common/Pagination'

import { cloneDeep } from 'lodash'
export default {
  components: {
    ChooseNegotiationV2Drawer,
    BaseSectionTitle,
    Pagination
  },

  model: {
    event: 'change',
    prop: 'list'
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },

    inStatus: {
      type: Array,
      default: () => []
    },

    // 是否可以编辑谈判单名称
    canEditOrder: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      negotiationName: '',
      orderList: [],
      orderListTmp: [], // 暂存的谈判单信息
      filterOrderList: [],
      editOpen: false, // 开启编辑谈判单
      page: 1,
      size: 10,
      total: 0
    }
  },

  watch: {
    list: {
      handler: function(val) {
        this.orderList = cloneDeep(val) || []
        this.orderListTmp = cloneDeep(val) || []
        this.search()
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 从列表里面移除该项
     */
    async remove(index) {
      await this.$confirm('删除后无法恢复，确定么？', '删除确认', {
        type: 'warning',
        confirmButtonText: '删除'
      })
      this.orderList.splice(index, 1)
      this.orderListTmp.splice(index, 1)
      this.search()
      if (this.filterOrderList.length === 0 && this.page > 0) {
        this.page = this.page - 1
        this.search()
      }
      this.$emit('change', this.orderList)
    },

    /**
     * 修改orderList
     */
    setOrderList(data) {
      this.orderList = cloneDeep(data)
      this.orderListTmp = cloneDeep(data)
      this.search()
      this.$emit('change', this.orderList)
    },

    /**
     * 查询筛选
     */
    search() {
      const filterOrderList =
        this.orderList.filter(el =>
          el.orderName.includes(this.negotiationName)
        ) || []
      this.total = filterOrderList.length || 0
      const largestPage = Math.ceil(this.total / this.size) || 1
      if (this.page > largestPage) {
        this.page = largestPage
      }
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.filterOrderList = filterOrderList.slice(start, end)
    },

    /**
     * 保存修改后的谈判单
     */
    saveEditOrder() {
      const valid = this.orderList.every(item => item.orderName)
      if (!valid) {
        this.$message.warning('请输入谈判单名称')
        return
      }
      this.editOpen = false
      this.search()
      this.$emit('change', this.orderList)
    },

    /**
     * 取消保存
     */
    cancelEditOrder() {
      this.orderList = cloneDeep(this.orderListTmp)
      this.search()
      this.editOpen = false
    }
  }
}
</script>
<style lang="scss" scoped>
.choose-title {
  span {
    color: $third-text-color;
    font-size: 14px;
    margin-left: 16px;
  }
}
.choose-operation {
  ::v-deep {
    .el-input-group {
      width: 300px;
    }
    .el-input-group__append {
      background-color: $primary-color;
      color: $white-color;
    }
  }
}
.order-list {
  border-top: 1px solid $dividing-color;
  .order-list_content {
    border-bottom: 1px solid $dividing-color;
    .order {
      font-size: 14px;
      padding: 16px 0;
      max-width: 90%;
      .order_title {
        color: $text-color;
        @include text-bold;
      }
      .order_tip {
        color: $third-text-color;
        margin-top: 8px;
      }
    }
  }
  .no-data {
    width: 184px;
    margin: 100px auto;
    img {
      width: 100%;
    }
    .no-data_content {
      text-align: center;
      color: $second-text-color;
      font-size: 14px;
      margin-top: 16px;
    }
  }
}

::v-deep {
  .el-scrollbar {
    max-height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
